import React from 'react';
import PropTypes from 'prop-types';
import { Add, Edit, InfoOutlined } from '@mui/icons-material';
import RowContextMenu from '../../components/DataGrid/RowContextMenu';
import DataGrid from '../../components/DataGrid/DataGrid';
import Status from '../../components/DataGrid/Status';
import PromotionEditor from './PromotionEditor';
import PromotionDetails from './PromotionDetails';
import { Box } from '@mui/material';
import DetailDialog from '../../components/DetailDialog/DetailDialog';

const Promotions = ({ id }) => {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [current, setCurrent] = React.useState(null);
    const [dlgTitle, setDlgTitle] = React.useState(null);
    const [operation, setOperation] = React.useState(null);
    const columns = [
        { field: "text", headerName: "Text", align: "left", filterable: true, permanent: true, },
        { field: "url", headerName: "URL", align: "left", filterable: true, permanent: true, },
        { field: "start_date", headerName: "Start", align: "left", filterable: true, permanent: true, },
        { field: "end_date", headerName: "End", align: "left", filterable: true, permanent: true, },
        { field: "isActive", headerName: "Status", align: "center", filterable: true,
            render : (row) => <Status value={row.isActive} />
         },
    ];

    // Define actions outside the RowContextMenu
    const rowActions = [
        { name: "Info", icon: <InfoOutlined fontSize="small" color='primary' />, onClick: (row) => {
            setCurrent(row);
            setOperation('INFO')
            setDlgTitle("Iformation")
            setOpenDialog(true);
        } },
        { name: "Edit", icon: <Edit fontSize="small" color='secondary' />, onClick: (row) => {
            setCurrent(row);
            setOperation('EDIT')
            setDlgTitle("Update a promotion")
            setOpenDialog(true);
        } },
    ];

    const headerActions = [
        { name: "Add", icon: <Add fontSize="small" color='secondary' />, onClick: () => {
            setCurrent({id:0});
            setOperation('EDIT')
            setDlgTitle("Create a promotion")
            setOpenDialog(true)} 
        },
    ];

    const CustomRowContextMenu = (props) => {
        return <RowContextMenu {...props} actions={rowActions} />
    }

    return (
        <div>
            <DataGrid 
                columns={columns} 
                endPoint={`/api/v2/partner/${id}/announcements`}  
                RowContextMenu={CustomRowContextMenu} 
                headerActions={headerActions}
                exportFileName='Promotions' 
            />
            <DetailDialog 
                open={openDialog} 
                onClose={()=>setOpenDialog(false)} 
                title={dlgTitle}
                fullScreen={false}>
                    <Box sx={{p:1}}>
                        {operation==='EDIT' && <PromotionEditor 
                            idPartner={id} 
                            idPromotion={current?.id}
                            onCancel={()=>setOpenDialog(false)} onSave={()=>{
                                setOpenDialog(false);
                            }} 
                        />}
                        {operation==='INFO' && <PromotionDetails 
                            idPartner={id} 
                            idPromotion={current?.id}
                            onBack={()=>setOpenDialog(false)} 
                        />}
                    </Box>
            </DetailDialog>
        </div>
    );
};

Promotions.propTypes = {
    id: PropTypes.string.isRequired,
};

export default Promotions;